import {SocialIcons} from '../SocialIcons';

export const Contact = () => (
  <div className='text-center pt-5'>
    <p>sepidar.theater@gmail.com</p>
    <SocialIcons />
  </div>
)